// extracted by mini-css-extract-plugin
module.exports = {"root":"teacherDetailTab_root__lQ_G5","list":"teacherDetailTab_list__3d76l","panel":"teacherDetailTab_panel__roNQl","tab":"teacherDetailTab_tab__klK7l"};